import { render } from "./status-alert.vue?vue&type=template&id=491728a5"
import script from "./status-alert.vue?vue&type=script&lang=js"
export * from "./status-alert.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ars62917/Dropbox/voteomatic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__